export default {
  getReplacementOptions: (state) => {
    const options = [
      {
        label: 'Brand',
        value: 'brand',
        example: 'Alltime Travel',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Domain',
        value: 'domain',
        example: 'alltime-travel.dk',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Booking Ref',
        value: 'bookingRef',
        example: 'AT1000000',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Customer Ref',
        value: 'customerRef',
        example: '111111',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Customer Name',
        value: 'customerName',
        example: 'Placeholder Name',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Family Name',
        value: 'familyName',
        example: 'Placeholder',
        compatibleTriggers: [1, 2, 3],
      },
      {
        label: 'Amount Due',
        value: 'amountDue',
        example: '102,4',
        compatibleTriggers: [1],
      },
      {
        label: 'Currency',
        value: 'currency',
        example: 'kr.',
        compatibleTriggers: [1],
      },
      {
        label: 'Due Date',
        value: 'dueDate',
        example: '01-01-2020',
        compatibleTriggers: [1],
      },
    ];

    return options.filter(
      option => option.compatibleTriggers.includes(state.templates.triggerType.id));
  },
  getAttachmentOptions() {
    return [
      { id: 'invoice', name: 'Invoice' },
    ];
  },
  getExceptionTypes() {
    return [
      {
        type: 'amount',
        name: 'Amount',
        component: 'amount',
        labels: [{ label: 'Amount', value: 'minimumAmount' }],
        compatibleTriggers: [1],
      },
      {
        type: 'remark',
        name: 'Remark',
        component: 'remark',
        compatibleTriggers: [1],
      },
    ];
  },
  getRevisionHeaders() {
    return [
      { text: 'Revision', value: 'revision' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Created By', value: 'userId' },
      { text: 'Action', sortable: false, width: '75px', class: 'text-xs-center' },
    ];
  },
  usedTemplates: (state) => {
    const templateIds = {};
    state.rules.rules.item.templates.forEach((item) => {
      templateIds[item.templateId] = true;
    });
    return templateIds;
  },
  getOverviewPoints() {
    return [
      { value: 'overdue', label: 'Overdue Without Triggers' },
      { value: 'lastTrigger', label: 'Last Trigger' },
    ];
  },
  getSettingHeaders() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Type', value: 'type' },
      { text: 'Settings', value: 'data' },
      { text: 'Trigger Type', value: 'triggerType.type' },
      { text: 'Created By', value: 'user.firstName' },
      { text: 'Last Update', value: 'updatedAt' },
      { text: 'Status', sortable: false, width: '50px' },
    ];
  },
  getGlobalExceptionTypes() {
    return [
      { text: 'Date', value: 'date' },
      { text: 'Period', value: 'period' },
      { text: 'Weekday', value: 'weekday' },
    ];
  },
  getSettingsLogsHeaders() {
    return [
      { text: 'Updated By', value: 'user.firstName', sortable: false },
      { text: 'Updated At', value: 'createdAt' },
      { text: 'Action', value: 'action', sortable: false },
      { text: 'Comment', value: 'comment', sortable: false, width: '60px' },
    ];
  },
  getSettingActionTypes() {
    return {
      all: { text: 'All', value: 'all' },
      delete: { color: 'error--text', text: 'Delete', value: 'delete' },
      activate: { color: 'warning--text', text: 'Activate', value: 'activate' },
      update: { color: 'green--text', text: 'Update', value: 'update' },
      create: { color: 'info--text', text: 'Create', value: 'create' },
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/triggers/getters.js